export default __webpack_public_path__ + "static/media/SDP_dark.c15430bf.png";